import * as t from "io-ts";
import nullable from "./nullable";
export const fractionUnitValues = ["kg", "ton"];
export const createFractionTypes = ({ decimal, }) => {
    const baseFractionT = t.strict({
        name: t.string,
        code: nullable(t.string),
        color: nullable(t.string),
        unit: t.string,
        eakCode: nullable(t.string),
        productId: nullable(t.string),
        salesPrice: nullable(decimal),
    });
    const fractionT = t.intersection([
        baseFractionT,
        t.strict({ id: t.string }),
    ]);
    const fractionsT = t.array(fractionT);
    return { baseFractionT, fractionT, fractionsT };
};
//# sourceMappingURL=fraction.js.map